import { Component, OnInit } from '@angular/core';
import { DpLandscapeReport, ReportBuilderService } from '../../report-builder.service';
import { KeyValue } from '@angular/common';
import { SortUtils } from '../../../../shared/utils/sort-utils';


@Component({
  selector: 'cm-report-presets-dp-landscape',
  templateUrl: './report-presets-dp-landscape.component.html',
  styleUrls: ['./report-presets-dp-landscape.component.scss']
})
export class ReportPresetsDpLandscapeComponent implements OnInit {
  report: DpLandscapeReport;
  loading = true;

  constructor(private service: ReportBuilderService) {
  }

  ngOnInit(): void {
    this.loading = true;
    this.service.presetReportsDpLandscape().subscribe(next => {
      this.loading = false;
      this.report = next;
      if (this.report) {
        this.report.unitDpStats.sort(SortUtils.propertyComparatorNumber('countPending', 'desc'));
      }
    }, () => {
      this.loading = false;
    });
  }

  compare(a: KeyValue<String, number>, b: KeyValue<String, number>) {
    return a.value > b.value ? -1 : b.value > a.value ? 1 : 0;
  }


}
